//获取用户信息
import { Apifetch } from "../utils/request";
const prefix = process.env.NODE_ENV === "development" ? "/api" : "";
export function getUserInfo() {
  const requestParams = {
    method: "get",
    body: {},
    url: `${prefix}/fgw/actsrv-year-summary/user/info`,
  };
  return Apifetch(requestParams);
}

export function getUserInfo2() {
  const requestParams = {
    method: "get",
    body: {},
    url: `${prefix}/mailplus/api/user/info/detail2`,
  };
  return Apifetch(requestParams);
}

export function getIfActivityExpired() {
  // 通过接口是否code 1005来判断是否过期
  const requestParams = {
    method: "get",
    body: {},
    url: `${prefix}/fgw/actsrv-year-summary/user/info`,
  };
  return Apifetch(requestParams);
}

export function getWorkData({mastersess, masterfp}: { mastersess?: string, masterfp?: string }) {
  const headers: any = {}
  mastersess && (headers.mastersess = mastersess);
  masterfp && (headers.masterfp = masterfp);
  const requestParams = {
    method: "get",
    headers,
    body: {},
    url: `${prefix}/fgw/actsrv-year-summary/data`,
  };
  return Apifetch(requestParams);
}
